import { render } from "./HeaderView.vue?vue&type=template&id=18917b3e&scoped=true"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=18917b3e&scoped=true&lang=scss"

import exportComponent from "C:\\Git\\Odelib\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18917b3e"]])

export default __exports__